export default __webpack_public_path__ + "static/media/showcase@2x.73c58f9a.jpg";